export enum LocationEditingMode {
  NOT_EDITING,
  EDIT_SENSOR_LOCATION,
  EDIT_FEATURE_LOCATION,
  ADD_FEATURE_LOCATION,
}
